import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/category?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20technology%20background%20with%20warm%20orange%20and%20teal%20gradient%20accents%2C%20soft%20geometric%20shapes%2C%20clean%20digital%20texture%2C%20subtle%20grid%20pattern%2C%20bright%20and%20airy%20atmosphere%2C%20professional%20tech%20company%20website%20backdrop%2C%20high%20quality%20abstract%20digital%20art&width=1800&height=700&seq=hero-bg-aiye-2026&orientation=landscape"
          alt="爱液下载背景"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
          安全 · 快速 · 免费
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 max-w-xl mx-auto leading-relaxed">
          爱液下载为您提供海量正版资源一键下载服务，覆盖系统工具、办公软件、游戏娱乐等八大品类，让您轻松获取所需资源
        </p>

        <form onSubmit={handleSearch} className="flex flex-col sm:flex-row items-center gap-3 max-w-lg mx-auto">
          <div className="relative w-full">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="输入关键词搜索资源..."
              className="w-full pl-11 pr-4 py-3.5 text-sm bg-white/95 backdrop-blur-sm border-0 rounded-full text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 transition-all"
            />
          </div>
          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            搜索资源
          </button>
        </form>

        <div className="flex items-center justify-center gap-6 mt-8 flex-wrap">
          {['100%安全检测', '极速下载体验', '多平台兼容'].map((tag) => (
            <div key={tag} className="flex items-center gap-1.5 text-white/80 text-sm">
              <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
              <span>{tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}